import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import SmallBusinessHeader from '../components/SmallBusinessHeader';

import SmallBusinessHero from './small-business/SmallBusinessHero';
import Workflow from './small-business/Workflow';
import PainPoints from './small-business/PainPoints';
import LocalFirst from './small-business/LocalFirst';
import SmallBusinessPricing from './small-business/Pricing';
import SmallBusinessFAQ from './small-business/SmallBusinessFAQ';
import ContactInfo from './small-business/ContactInfo';

const PAGE_TITLE =
  'Vendor Invoice Organization Software for Small Business Back Office | Sortio';
const PAGE_DESCRIPTION =
  'AI bookkeeping file organizer for vendor invoice routing, AP filing automation, and multi-year payroll archives on OneDrive, Dropbox, and SharePoint. Renames files to YYYYMMDD, Vendor, Amount. Built for bookkeepers, AP admins, and back office teams at construction, trucking, and service SMBs.';
const PAGE_KEYWORDS =
  'vendor invoice organization software, automate accounts payable filing, AI bookkeeping file organizer, organize payroll archive, QuickBooks Xero document organizer, small business file management software, construction company invoice organization, trucking company payroll archive, AP automation, records retention software';

const SmallBusinessPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'small-business' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta name="keywords" content={PAGE_KEYWORDS} />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.getsortio.com/for-small-business-back-office"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
        <link
          rel="canonical"
          href="https://www.getsortio.com/for-small-business-back-office"
        />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-12T00:00:00.000Z"
        dateModified="2026-05-12T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <SmallBusinessHeader />
      <SmallBusinessHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <LocalFirst />
          <SmallBusinessPricing />
          <SmallBusinessFAQ />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default SmallBusinessPage;
